import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Footer from "../components/footer";
import NavigationBar from "../components/navigationbar";
import MobileNavigationBar from "../components/mobileNavbar";
import MobileFooter from "../components/mobileFooter";
import { isMobile } from "react-device-detect";
import greenBanner from "../assets/greenbanner.png";

// Updated Arabic Content
const arabicContent = (
    <div dir="rtl" className="arabic-content" >
        <h1>سعيدون لتقديمكم طلب المساعدة</h1>
        <h3>  للعلم: جميع مساجد المدينة موحدة تحت لجنة زكاة استن العظمى. طلب واحد, لجنة واحدة , قرار واحد        </h3>
        <h3>نرجو التأكد من الشروط التالية:</h3>
        <ul >
            <li>أن يكون المتقدم رب الأسرة من الذكور.</li>
            <li>
                إذا كانت المتقدمة أخت وحيدة، مطلقة أو منفصلة، عليها
                <a href="https://www.mcssaustin.org/get-help/"> الضغط هنا</a>
            </li>
            <li>
                إذا كنت بحاجة للمساعدة لدفع فاتورة الكهرباء
                <a href="https://www.mcssaustin.org/utility-bill-assistance/"> اضغط هنا</a>
            </li>
            <li>الأولوية للمنتظمين في مساجد المدينة.</li>
            <li>يشترط بالمتقدم ان يكون لديه عنوان في مدينة استن وما جاورها. (استن, راوند روك, فلوجيرفل , سيدار بارك, ليندار, جورج تاون, مينير, بيودا , كايل)</li>
            <li>لن تستطيع اللجنة مساعدة أي متقدم خارج هذه المدن.</li>
            <li>لا تقدم اللجنة مساعدات لتغطية تذاكر سفر: طائرة، سيارة، أو قطار.</li>
            <li>لا تقدم اللجنة أي مبالغ نقدية. يتم الدفع مباشرة للإيجار أو شركة الخدمات.</li>
            <li>لا تدفع اللجنة للبقاء في فندق (يجب أن يكون المتقدم مقيماً في المدينة).</li>
            <li>لا تقبل اللجنة ورقة طلب الإخلاء أو فصل الخدمات بعد إصدارها.</li>
            <li>لا تساعد اللجنة الذين يقومون بكسر عقد الإيجار إلا إذا كان هناك سبب مقبول لذلك.</li>
            <li>
                على المتقدم من الذكور تقديم ما يلي:
                <ul>
                    <li>هوية المتقدم وزوجته.</li>
                    <li>عقد الايجار اصلي من المكتب.</li>
                    <li>فاتورة الكهرباء اصلية من الشركة.</li>
                    <li>ثلاثة شهور من الحساب البنكي.</li>
                    <li>ثلاثة شهور اثبات صكوك الدفع من رب العمل.</li>
                </ul>
            </li>
            <li>يطلب المتقدم للمقابلة مع لجنة الزكاة الموحدة.</li>
            <li>
                اذا كنت مكتمل الشروط اعلاه
                <a href="https://austinmosque.org/client-application-for-assistance/">اضغط هنا للتقديم</a>
            </li>
            <li>يجب التقديم في بداية الشهر للحصول على المساعدة للشهر المطلوب</li>
            <li>لايسمح للاجئين الذين يتلقون مساعدات من المنظمات الدولية ان يتقدموا بطلب للمسجد الا  اذا كانوا بحاجة للاثاث اومشابه.</li>
            <li>
                المنظمات التى تنسق مع المساجد:
                <ul>
                    <li>World Relief, AFSSA, MCSS, HIAS, ICNA, Catholic Charities, TXOR, Amanah</li>
                </ul>
            </li>
        </ul>
        <h4>
        </h4>
    </div>
);

// English Content (unchanged)
const englishContent = (
    <>
        <h4>
            We are pleased you have applied for help with us, please note: <br />
            All the mosques and charitable organizations are under Greater Austin Muslim Relief Committee (GAMRC),
            Austin unified charity committee: One application, one committee, one decision.
        </h4>
        <h4>Before applying, please read the following:</h4>
        <ul>
            <li>Only the male household head needs to apply.</li>
            <li>We can help once and more than once for those eligible if it is proven they need help.</li>
            <li>
                If the applicant is a single mom, widowed, divorced or separated then she needs to apply to our sister organization. <a href="https://www.mcssaustin.org/get-help/">Click here</a>
            </li>
            <li>
                If you need help with your electric bill <a href="https://www.mcssaustin.org/utility-bill-assistance/">click here</a>
            </li>
            <li>Priority is for the regular attendees of our mosques.</li>
            <li>It is required for the applicant to have an address in the following cities: Austin, Cedar Park, Round Rock, Leander, Pflugerville, Manor, Georgetown, Kyle, and Buda.</li>
            <li>The committee will not be able to help applicants from outside of these cities.</li>
            <li>The committee doesn’t help with travel costs or tickets of planes, buses, or trains and we don’t pay for the use of Uber or car rentals.</li>
            <li>The committee doesn’t pay cash for any reason (except for little cash for zakat ul Fitr). All checks will be paid directly to the rent or utility bills.</li>
            <li>The committee does not pay for hotel or motel stays. You must have an established residence in the cities listed above.</li>
            <li>The committee will not help with eviction notices or disconnecting notices. You must contact us before the notices are issued.</li>
            <li>The committee will not help with broken residential leases unless there is a valid reason to do so.</li>
            <li>
                The male applicant needs to submit the following before we review the case:
                <ul>
                    <li>His ID and the ID of his wife.</li>
                    <li>Lease agreement or mortgage statement in original form (PDF format).</li>
                    <li>Electric bill original in PDF format from the electricity company.</li>
                    <li>Three most recent bank statements.</li>
                    <li>Three most recent paystubs from the employer.</li>
                </ul>
            </li>
            <li>The applicant will be called for an interview.</li>
            <li>If you are ready to apply <a href="https://austinmosque.org/client-application-for-assistance/">click here</a>.</li>
            <li>You must apply the first day of the month to get help for that month.</li>
            <li>It is not allowed for new refugees to apply if they are still receiving help from any refugee organizations, except to request some furniture.</li>
            <li>
                GAMRC coordinates with the following charitable organizations:
                <ul>
                    <li>World Relief, AFSSA, MCSS, HIAS, ICNA, Catholic Charities, TXOR, Amanah</li>

                </ul>
            </li>
        </ul>
    </>
);

// Pashto Content
const pashtoContent = (
    <div dir="rtl" className="pashto-content">
        <h4>
            موږ خوښ یو چې تاسو زمونږ څخه د مرستې لپاره غوښتنه کړې ده، مهرباني وکړئ په یاد ولرئ:
            <br />
            ټول جوماتونه او خیریه بسټونه د لوی آسټین مسلم ریلیف کمیټې (GAMRC)، د آسټین متحد خیریه کمیټې لاندې دي: یو غوښتنلیک، یوه کمیټه، یوه پریکړه.
        </h4>
        <h4>د غوښتنلیک ورکولو دمخه، مهرباني وکړئ لاندې ښه په دقت ولولئ:</h4>
        <ul>
            <li>یوازې د کورنۍ نارینه مشر باید غوښتنه وکړي.</li>
            <li>موږ کولی شو د هغو کسانو لپاره یو ځل او څو ځله مرسته وکړو چې مستحق دي که چیرته دا په اثبات ورسید چې دوی مرستې مستحقین دي.</li>
            <li>
                که غوښتونکی یوازینۍ مور وي، کونډه وي، طلاق شوی وي یا خپل میړه څخه بیل شوی وي نو هغه باید زموږ د خور سازمان ته غوښتنه وکړي.
                <a href="https://www.mcssaustin.org/get-help/"> دلته کلیک کړئ</a>
            </li>
            <li>
                که تاسو د خپل بریښنا بل سره مرستې ته اړتیا لرئ
                <a href="https://www.mcssaustin.org/utility-bill-assistance/"> دلته کلیک وکړئ</a>
            </li>
            <li>زموږ لومړیتوب د جوماتونو منظم ګډون کونکو لپاره دی.</li>
            <li>غوښتونکي ته اړتیا ده چې په لاندې ښارونو کې وأوسیږي: آسټین، سیډر پارک، راؤنډ راک، لیانډر، فلوګر ویل، مینور، جورج ټاون، کایل، او بودا.</li>
            <li>کمیټه به د دې ښارونو څخه بهر د غوښتونکو سره مرسته ونکړي.</li>
            <li>کمیټه د الوتکو، بسونو یا ریل ګاډو د سفر لګښتونو یا ټکټونو سره مرسته نه کوي او موږ د اوبر یا موټر کرایې کارولو لپاره پیسې نه ورکوو.</li>
            <li>کمیټه د هیڅ دلیل لپاره نغدي پیسې نه ورکوي (پرته له دې چې د زکات الفطر لپاره لږې پیسې). ټول چیکونه به په مستقیم ډول د کرایې یا د خدماتو بیلونو ته ورکړل شي.</li>
            <li>کمیټه د هوټل یا میلمستون د پاتې کیدو لپاره پیسې نه ورکوي. تاسو باید په پورته لیست شوي ښارونو کې یو ثابت استوګنځی ولرئ.</li>
            <li>کمیټه به د ویستلو خبرتیاو یا د قطع کولو خبرتیاو سره مرسته ونکړي. تاسو باید د خبرتیاو له خپریدو دمخه موږ سره اړیکه ونیسئ.</li>
            <li>کمیټه به د آپارتمان یا کور اجارې/کرایه ماتونکي سره مرسته ونکړي پرته لدې چې یو معتبر دلیل شتون ولري.</li>
            <li>
                نارینه غوښتونکی باید لاندې شیان وسپاري مخکې لدې چې موږ قضیه بیاکتنه وکړو:
                <ul>
                    <li>د هغه ID او د هغه د میرمن ID.</li>
                    <li>د اجارې تړون یا لیس کانټرکټ په اصلي بڼه (PDF بڼه).</li>
                    <li>د بریښنا شرکت څخه د PDF بڼه کې د بریښنا بل اصلي.</li>
                    <li>د بانک درې میاشتني وروستي بیانونه.</li>
                    <li>د کار ورکوونکي څخه درې وروستي معاشونه.</li>
                </ul>
            </li>
            <li>غوښتونکی به د مرکې لپاره وغوښتل شي.</li>
            <li>که تاسو د غوښتنلیک ورکولو لپاره چمتو یاست <a href="https://austinmosque.org/client-application-for-assistance/">دلته کلیک وکړئ</a>.</li>
            <li>تاسو باید د میاشتې په لومړۍ ورځ غوښتنه وکړئ ترڅو د هغې میاشتې لپاره مرسته ترلاسه کړئ.</li>
            <li>د نویو کډوالو لپاره اجازه نشته چې غوښتنه وکړي که چیرې دوی لاهم د کوم کډوالو سازمان څخه مرسته ترلاسه کوي، پرته له دې چې د ځینو فرنیچر غوښتنه وکړي.</li>
            <li>
                GAMRC د لاندې خیریه سازمانونو سره همغږي کوي:
                <ul>
                    <li>World Relief, AFSSA, MCSS, HIAS, ICNA, Catholic Charities, TXOR, Amanah</li>
                </ul>
            </li>
        </ul>
    </div>
);


// Main Component
export const ApplyForHelp = () => {
    const [language, setLanguage] = useState("en");

    return (
        <div className="home-page">
            {isMobile ? <MobileNavigationBar /> : <NavigationBar />}

            {!isMobile && (
                <div
                    style={{
                        backgroundImage: `url(${greenBanner})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        padding: "1rem 3rem",
                        fontFamily: "Lora, serif",
                    }}
                >
                    <Container className="px-4 py-3">
                        <div style={{ fontSize: 14, paddingBottom: "1rem", textAlign: "center" }}>
                            Nueces Mosque • ICGA • ICRR • ICBC • ICLT • GIC • QCIC • Al-Noor MCC • ICHC
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "1rem", gap: "2rem", flexWrap: "wrap" }}>
                            <div style={{ flex: "1 1 300px", minWidth: "280px" }}>
                                <div style={{ fontSize: 32, fontWeight: "700", marginBottom: "0.5rem" }}>
                                    Greater Austin Muslim Relief Committee:
                                </div>
                                <div style={{ fontSize: 20, fontWeight: "600", paddingRight: "4rem" }}>
                                    A Unified Zakah Committee Nurturing Communities in The Greater Austin Area
                                </div>
                            </div>
                            <div style={{ flex: "1 1 400px", minWidth: "280px", display: "flex", flexDirection: "column" }}>
                                <p style={{ fontSize: 18, lineHeight: 1.5, marginBottom: "1.5rem" }}>
                                    The Greater Austin Muslim Relief Committee (GAMRC) is dedicated to providing financial and humanitarian assistance to community members in need. We serve all eight categories of Zakat, as outlined in Surah At-Tawbah, which include the poor, the needy, Zakat administrators, reconciled hearts, captives, debt ridden, Fi-Sabilillah, and travelers in need.
                                </p>
                            </div>
                        </div>
                    </Container>
                </div>
            )}

            <Container className="my-3">
                <Row>
                    <Col md={2}>
                        <h1 className="text-center mb-4">Applying For Help</h1>

                        <div className="d-flex flex-column gap-2 mb-4">
                            <button className={`btn btn-outline-success ${language === "en" ? "active" : ""}`} onClick={() => setLanguage("en")}>English</button>
                            <button className={`btn btn-outline-success ${language === "ar" ? "active" : ""}`} onClick={() => setLanguage("ar")}>العربية</button>
                            <button className={`btn btn-outline-success ${language === "ps" ? "active" : ""}`} onClick={() => setLanguage("ps")}>پښتو</button>
                        </div>
                    </Col>
                    <Col md={8} className="mx-md-4 mx-0">
                        {language === "en" && englishContent}
                        {language === "ar" && arabicContent}
                        {language === "ps" && pashtoContent}

                        <div className="d-flex flex-column gap-2 mb-4">
                            <Button
                                className="apply-now-button mt-4 align-center pt-2"
                                onClick={() =>
                                    window.open("https://austinmosque.org/client-application-for-assistance/", "_blank", "noopener,noreferrer")
                                }
                            >
                                <h4 className="py-0">Apply Now</h4>
                            </Button>

                        </div>
                    </Col>
                </Row>
            </Container>
            {isMobile ? <MobileFooter /> : <Footer />}
        </div>
    );
};

export default ApplyForHelp;